var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fusion-header"},[_c('div',{staticClass:"header-h1"},[_c('h1',[_c('a',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("MES"),_c('br')])])])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }